import React from "react";
import banner from "../assets/banner4.jpg";

export default function NdomanoPharmaceuticals() {
  return (
    <div className="MainBodySection py-5">
      <div className="container">
        <div className="row align-items-center mb-4">
          <div className="col-md-6 order-md-1 text-center">
            <img src={banner} alt="Ndomano Pharmaceuticals" className="img-fluid rounded" style={{maxHeight: '320px', objectFit: 'cover'}} />
          </div>
          <div className="col-md-6 order-md-2">
            <h2 className="main-section-title">Ndomano Pharmaceuticals (T) LTD</h2>
            <p className="text-muted">
              Ndomano Pharmaceuticals supplies retail and wholesale pharmaceutical products and locally produced nutrition items to support healthier communities. We prioritize quality sourcing, regulatory compliance, and accessible distribution channels.
            </p>
            <p className="text-muted">
              Our pharmacy and supply networks focus on making essential medicines and health products available to clinics, retailers, and consumers through reliable logistics and strong quality control measures.
            </p>
            <div className="my-3">
              <a className="btn btn-primary" href="https://ndomanopharmaceuticals.com" target="_blank" rel="noreferrer">Visit Ndomano Pharmaceuticals</a>
            </div>
          </div>
          
        </div>
      </div>
    </div>
  );
}
